<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <strong>お問合せフォーム</strong>
          </CCardHeader>
          <CCardBody>
            <CForm class="member-info">
              <Loading
              class="text-center"
              v-if="pageLoading"/>
              <CRow>
                <CCol lg="10">
                  <div class="text-danger input-info" v-if="!$v.application.summary.required">お問合せの概要は必須です</div>
                  <div class="text-danger input-info" v-if="!$v.application.summary.maxLength">100文字までしか入力できません</div>
                  <CInput
                    label="概要"
                    placeholder="お問合せ内容の概要を入力してください"
                    description="施設の料金について"
                    horizontal
                    required
                    maxLength
                    v-model="application.summary"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="10">
                  <div class="text-danger input-info" v-if="!$v.application.description.required">お問合せ内容は必須です</div>
                  <div class="text-danger input-info" v-if="!$v.application.description.maxLength">1000文字までしか入力できません</div>
                  <CTextarea
                    label="お問合せ内容"
                    placeholder="お問合せ内容を入力してください"
                    description="施設の料金はいくらですか？"
                    horizontal
                    required
                    maxLength
                    v-model="application.description"
                    rows="10"
                  />
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
          <CCardFooter>
            <CButton
              color="success"
              class="ml-0 px-5"
              :disabled="$v.$invalid"
              v-on:click="submitApplication"
            >
            送信
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <!-- start_completeModal -->
      <CModal
        :show.sync="completeModal"
        color="success"
        closeOnBackdrop
        :centered="true"
      >
        <p>お問合せ内容を送信しました</p>
        <template #header>
        送信完了

        </template>
        <template #footer>
          <CButton 
          @click="completeModal = false"
          color="secondary">閉じる</CButton>
        </template>
      </CModal>
    <!-- end_completeModal -->
    <!-- start_LoginErrorModal -->
      <CModal
        :show.sync="LoginErrorModal"
        color="danger"
        closeOnBackdrop
        :centered="true"
      >
        <p>お問合せ内容を送信できませんでした</p>
        <p>「閉じる」をクリックし、時間をおいて改めて送信してください</p>
        <template #header>
        送信システムエラー
        </template>
        <template #footer>
          <CButton 
          @click="LoginErrorModal = false"
          color="secondary">閉じる</CButton>
        </template>
      </CModal>
    <!-- end_LoginErrorModal -->
    <!-- start_inquiryCreateErrorModal -->
      <CModal
        :show.sync="inquiryCreateErrorModal"
        color="danger"
        closeOnBackdrop
        :centered="true"
      >
        <p>お問合せ内容を送信できませんでした</p>
        <p>「閉じる」をクリックし、再度「送信」ボタンを押してください</p>
        <template #header>
        送信エラー

        </template>
        <template #footer>
          <CButton 
          @click="inquiryCreateErrorModal = false"
          color="secondary">閉じる</CButton>
        </template>
      </CModal>
    <!-- end_inquiryCreateErrorModal -->
         

  </div>
</template>

<script>
import axios from "axios";
import { required,maxLength } from "vuelidate/lib/validators";
import inquiryData from "../assets/inquiryData.json";
import inquiryLoginUserData from "../assets/inquiryLoginUserData.json";
import inquiryRequestURL from "../assets/inquiryRequestURL.json";
import Loading from "../components/loading";

export default {
  name: "Inquiry",
  components: {
    Loading
    },
  data() {
    return {
       
      pageLoading:false,
      //モーダルの表示切り替え
      completeModal: false,
      LoginErrorModal: false,
      inquiryCreateErrorModal:false,
      application: {
        summary: "",
        description: "",
        priority: "",
        severity: "",
      },
    };
  },
  //入力項目にvalidation
  validations: {
    application: {
      summary: {
        required,
        maxLength:maxLength(100)
      },
      description: {
        required,maxLength:maxLength(1000)
      },
    },
  },
  beforeMount() {
    //console.log("ページ更新03");
    //TODO:ページ読み込み時にユーザーの権限取得してページの表示非表示の判断するように処理する
  },
  methods: {
    resetInput: function() {
        this.application.summary=''
        this.application.description=''
        this.application.priority=''
        this.application.severity=''
    },
    submitApplication: function () {

      //ローディング表示
      this.pageLoading = true;
      //bugzillaに用意されている値を用意
      var inquiryInfo = {
        component: inquiryData.component,
        product: inquiryData.product,
        version: inquiryData.version,
        summary: "",
        alias: "",
        op_sys: inquiryData.op_sys,
        rep_platform: inquiryData.rep_platform,
        severity: inquiryData.severity,
        priority: inquiryData.priority,
        url: "",
        deadline: "",
        description: "",
      };
      //入力した内容をbugzillaに用意された値に入力情報を代入
      //Create the information
      inquiryInfo.summary = this.application.summary;
      inquiryInfo.description = this.application.description;

      //Severity, Priority and Deadline
      // inquiryInfo.severity = this.application.severity;
      // inquiryInfo.priority = this.application.priority;
      // inquiryInfo.deadline = this.application.deadline;
      //inquiryInfo.url = this.application.url;

      //送信する情報表示
      //console.log(inquiryInfo);

      //bugzillaにログインする
      //bugzillaアカウント情報
      var email = inquiryLoginUserData.email;
      var password = inquiryLoginUserData.password;
      //var password = "errorPassword";
      // //tokenを入れる変数用意
      var token = "";
      // var userid = "";
      
            //ログインリクエスト
      var bugzillaLoginRequest =
        inquiryRequestURL.URL +
        "/rest/login?login=" +
        email +
        "&password=" +
        password;
      axios({ url: bugzillaLoginRequest, method: "GET" })
        .then((resp) => {
          //bugzillaログイン成功
          token = resp.data.token;
          //console.log(resp);

          //送信エラー表示用トークン
          //token = "errorToken";
          //userid = resp.data.id;
          console.log("LoginSuccess");
          console.log(resp);

          //Bugzillaに内容登録リクエスト
          var bugzillaSaveRequest =
            inquiryRequestURL.URL + "/rest/bug?token=" + token;
          axios({ url: bugzillaSaveRequest, data: inquiryInfo, method: "POST" })
            .then((resp) => {
              //bugzilla登録成功
              const bugid = resp.data.id;
              console.log("bugSaveSuccess");
              //console.log(resp);
              //console.log("new bug id:" + bugid);
              

              //restAPIへのPostRequestのbody情報用意
              var userInquery = {
                bugId: bugid,
                summary: inquiryInfo.summary,
              };
              //restAPIにbugIDと概要を送信してユーザーと紐づける
              var userInquiryRequest =
                "/rest/users/" + this.$keycloak.userName + "/issues";
              axios.post(userInquiryRequest, userInquery, {headers: {"Authorization" : `Bearer ${this.$keycloak.token}` }})
                .then((resp) => {
                  //restAPI登録成功
                  //console.log(resp);
                  console.log("userInquirySaveSuccess");
                  console.log(resp);

                  //完了ダイアログ表示
                  this.completeModal = true;
                  //ローディング非表示
                  this.pageLoading=false;

                  //入力フォームリセット
                  this.resetInput();
                })
                .catch((err) => {
             

                  //restAPI登録失敗
                  this.inquiryCreateErrorModal = true;
                  //ローディング非表示
                  this.pageLoading=false;
                  console.log("userInquirySaveFailed");
                  console.log(err);
                });
            })
            .catch((err) => {
             

              //bugzilla登録失敗
              this.inquiryCreateErrorModal = true;
                  console.log(err);

              //ローディング非表示
                  this.pageLoading=false;
              console.log("bugSaveFailed");
              console.log(err);
            });
        })
        .catch((err) => {
             

          //bugzillaログイン失敗
          this.LoginErrorModal = true;
          console.log("LoginFailed");
          console.log(err);
        });
    },
  },
};
</script>
